import { classNames } from "../../utils"

export const customScrollbarClassname = classNames(
  "[&::-webkit-scrollbar-thumb]:rounded [&::-webkit-scrollbar-thumb]:bg-bg-additional-3",
  "[&::-webkit-scrollbar-thumb]:hover:bg-bg-additional-3 [&::-webkit-scrollbar-thumb]:active:bg-bg-additional-3",
  "[&::-webkit-scrollbar-track]:bg-bg-app [&::-webkit-scrollbar]:size-2 [&::-webkit-scrollbar]:bg-bg-app",
)
